import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
const SocialButton = (props) => {
  return (
    <Box>
      <Link
      component={Link}
      fontSize={["1.5rem", "1.5rem", "1.5rem", "1.5rem", "1.5rem"]}
        sx={{
          backgroundColor: "transparent",
          padding: "2px 6px 2px 6px ",
          textDecoration: "none",
          font: "bold 11px Arial",
          color: "#54b3d6",
          boxShadow: "inset 0 0 0 0 #54b3d6",
          transition: "color .3s ease-in-out, box-shadow .3s ease-in-out",
          "&:hover": {  boxShadow: "inset 100px 0 0 0 #e1ad01" , color: "#FFFFFF", },
        }}
        href={[props.link]}
        underline="none"
      >
        {props.name}
      </Link>
    </Box>
  );
};
export default SocialButton;
